import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Fornecedor } from 'src/app/models/fornecedor';
import { ProdutoFornecedorValor } from 'src/app/models/produto-fornecedor-valor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';

@Component({
  selector: 'app-produto-cdmodal',
  templateUrl: './produto-cdmodal.component.html',
  styleUrls: ['./produto-cdmodal.component.scss']
})
export class ProdutoCDModalComponent implements OnInit {
  valores: ProdutoFornecedorValor;

  cds: Fornecedor[] = [];
  cdsJaUsados: number[] = [];

  constructor(
    private dialogRef: MatDialogRef<ProdutoCDModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private produtoService: ProdutoService,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService,
    private fornecedorService: FornecedorService
  ) {
    this.valores = data.valores;
    this.cdsJaUsados = data.cdsJaUsados;
  }

  ngOnInit(): void {
    this.buscarCDs();
  }


  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;

        if (this.cdsJaUsados !== null && this.cdsJaUsados !== undefined && this.cdsJaUsados.length > 0){
          this.cds = this.cds.filter(p => !this.cdsJaUsados.some(c => c === p.id));
        }

        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  salvar() {

    this.valores.precoAvulso = Number(this.valores.precoAvulso);
    this.valores.precoCusto = Number(this.valores.precoCusto);
    this.valores.precoVenda = Number(this.valores.precoVenda);
    this.valores.qtEstoque = Number(this.valores.qtEstoque);

    this.valores.margemPrecoVenda = Number((100 - (this.valores.precoCusto / this.valores.precoVenda * 100)).toFixed(2));
    this.valores.margemPrecoAvulso = Number((100 - (this.valores.precoCusto / this.valores.precoAvulso * 100)).toFixed(2));

    this.carregandoService.mostra('salvaProduto');

    this.produtoService.salvarValoresFornecedor(this.valores).subscribe(
      (retorno) => {

        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
